import { createFileRoute } from "@tanstack/react-router";
import MedicationManagementPage from "@/pages/MedicationManagementPage";
export const Route = createFileRoute("/services/medication-management")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Medication Management Coral Springs, FL | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Psychiatric medication management in Coral Springs, FL. Expert prescribing for depression, anxiety, and more at Neuro Wellness TMS Free consultation available.",
        },
        {
          property: "og:title",
          content:
            "Medication Management Coral Springs, FL | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Psychiatric medication management in Coral Springs, FL. Expert prescribing for depression, anxiety, and more at Neuro Wellness TMS Free consultation available.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/services/medication-management",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/services/medication-management",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <MedicationManagementPage />;
}
